import { APIRequest } from './API';

export default class Forms {
	static async sendForm(type, fields) {
		fields['type'] = type;
		const result = await APIRequest('forms/send', fields);
		return result;
	}
}